<template>
	<div class="checkbox-group">
		<label class="label">
			{{ label }}
		</label>
		<erco-tooltip v-if="tooltip && tooltip.text"
		              :variant="tooltip.variant"
		              :title="tooltip.title"
		              :text="tooltip.text">
		</erco-tooltip>

		<div class="checkbox-container" :class="containerClasses">
			<b-form-checkbox v-for="(option, index) in options"
							 :key="index"
							 v-model="prepValue[index]"
							 :value="option.value"
							 unchecked-value=""
							 :disabled="option.disabled"
							 class="checkbox"
							 @change="handleChange(index, option.value, $event)">
				{{option.text}}
			</b-form-checkbox>
		</div>
	</div>
</template>
<script>

import ErcoTooltip from '@/components/molecules/ErcoTooltip';

export default {
	name: 'ErcoCheckboxGroupMolecule',

	props: {
		label: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
			default: [],
		},
		direction: {
			type: String,
			default: 'horizontal',
			validator: dir => ['vertical', 'horizontal'].includes(dir.toLowerCase()),
		},
		tooltip: {
			type: Object,
			required: false,
			default: () => ({ variant: '', title: '', text: '' }),
		},
	},

	components: {
		ErcoTooltip,
	},

	computed: {
		containerClasses() {
			const containerClasses = {};
			containerClasses[`-${this.direction.toLowerCase()}`] = true;
			return containerClasses;
		},

		prepValue() {
			return this.options.map(option => (option.checked ? option.value : ''));
		},

		selectedValues() {
			const selectedValues = {};

			this.value.forEach((value, index) => {
				const lang = this.options[index].value;
				selectedValues[lang] = (value === '' ? 0 : 1);
			});

			return selectedValues;
		},
	},

	methods: {
		handleChange(index, value, checked) {
			this.$emit('change', index, value, (checked !== ''));
		},
	},
};
</script>

<style lang="scss">

	.checkbox-group {
		& > .label {
			display: inline-block;
			margin-bottom: 0.5rem;
		}

		& > .checkbox-container {
			&.-horizontal {
				& > .checkbox {
					display: inline-block;
					min-width: 3rem;
				}
			}
			&.-vertical {
				& > .checkbox {
					display: block;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoCheckboxGroup.vue?09642cd2